import(/* webpackMode: "eager" */ "/app/src/app/blog/author/[slug]/not-found.js");
